import * as types from "./camposDinamicos.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";

export default {
  getCamposDinamicos: () => ({
    type: types.GET_CAMPOS_DINAMICOS,
  }),
  setCamposDinamicos: data => ({
    type: types.SET_CAMPOS_DINAMICOS,
    payload: data,
  }),
  resetFormDinamico: () => ({
    type: types.RESETFORM,
  }),
  resetForm: () => ({
    type: commonActionType.RESET,
  }),
};
